import React from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField';
import {withStyles} from 'material-ui/styles'
import styles from './styles'
import {validateFormData} from '../../../common/formtool'

class AccountLockoutSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: {},
      errors: {},
      accountLockoutSettings: {
        failedAttempts: 0,
        threshold: 0,
        duration: 0
      },
      isUpdateSettingBtnDisabled: true
    }
    this.onChange = this.onChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  onChange(e) {
    let accountLockoutSettings = {...this.state.accountLockoutSettings}
    accountLockoutSettings[e.target.name] = e.target.value
    let errors = {...this.state.errors}
    errors = {
      ...errors,
      [e.target.name]: false
    }
    this.setState({accountLockoutSettings: accountLockoutSettings, errors})
    let {isUpdateSettingBtnDisabled} = this.state
    if (isUpdateSettingBtnDisabled) {
      this.setState({isUpdateSettingBtnDisabled: false})
    }
  }

  handleSubmit() {
    let accountLockoutSettings = {...this.state.accountLockoutSettings}

    let validationData = {
      failedAttempts: {
        required: this.props.translate('formfield_error_general_required')
      },
      threshold: {
        required: this.props.translate('formfield_error_general_required')
      },
      duration: {
        required: this.props.translate('formfield_error_general_required')
      },
    }

    let errors = validateFormData(this.state.accountLockoutSettings, validationData);
    const missingFieldName = Object.keys(errors)[0]
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0]
      textField && textField.focus()
    }

    if (Object.keys(errors).length) {
      this.setState({errors: errors})
    } else {
      let self = this;
      this.props.update(accountLockoutSettings).then((_) => {
        self.setState({
          error: {},
          isUpdateSettingBtnDisabled: true
        })
      }).catch((_) => {
        // For debugging, console.log err

        // toast.error(this.props.translate('error_saving_settings'));

      })
      if (!this.state.isUpdateSettingBtnDisabled) {
        window.scrollTo(0, 0);
      }
    }
  }

  getUpdateError(error) {
    // No custom errors
  }

  render() {
    const {
      classes,
      translate,
      impersonating
    } = this.props

    const {
      accountLockoutSettings,
      error,
      errors,
      isUpdateSettingBtnDisabled
    } = this.state

    return (
      <Paper className={classes.paper}>
        <Grid container direction="row" justify="flex-start"
              alignItems="center">
          <Grid item xs={9}>
            <Typography type="title" gutterBottom>
              {translate("security_account_lockout_settings_tab")}
            </Typography>
          </Grid>
        </Grid>
        {error && this.getUpdateError(error)}
        <TextField
          required
          error={!!errors.failedAttempts}
          name="failedAttempts"
          label={translate("security_account_lockout_settings_failed_attempts")}
          margin="normal"
          fullWidth
          value={accountLockoutSettings.failedAttempts}
          onChange={this.onChange}
          helperText={errors.failedAttempts ? errors.failedAttempts : translate("security_account_lockout_settings_failed_attempts_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={!!errors.duration}
          name="threshold"
          label={translate("security_account_lockout_settings_threshold")}
          margin="normal"
          fullWidth
          value={accountLockoutSettings.threshold ? accountLockoutSettings.threshold : ''}
          onChange={this.onChange}
          helperText={errors.threshold ? errors.threshold : translate("security_account_lockout_settings_threshold_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={!!errors.duration}
          name="duration"
          label={translate("security_account_lockout_settings_duration")}
          margin="normal"
          fullWidth
          value={accountLockoutSettings.duration ? accountLockoutSettings.duration : ''}
          onChange={this.onChange}
          helperText={errors.duration ? errors.duration : translate("security_account_lockout_settings_duration_help")}
          disabled={impersonating}
        />
        <Button raised
                fullWidth
                color="primary"
                className={classes.update}
                type="submit"
                onClick={this.handleSubmit}
                disabled={isUpdateSettingBtnDisabled || impersonating}
        >
          {translate("profile_update_settings")}
        </Button>
      </Paper>
    )
  }

  componentDidMount() {
    if (this.props.accountLockoutSettings) {
      let accountLockoutSettings = {...this.props.accountLockoutSettings}
      this.setState({
        accountLockoutSettings
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.accountLockoutSettings && nextProps.accountLockoutSettings.id !== this.state.accountLockoutSettings.id) {
      let accountLockoutSettings = {...nextProps.accountLockoutSettings}
      this.setState({
        accountLockoutSettings
      })
    }
  }
}

export default withStyles(styles)(AccountLockoutSettings)
